import "zod-openapi/extend";

import { APIFieldLatest } from "server/services/tables/types/tables-latest";

export const ALLOWED_CHECKLIST_TITLE_FIELD_TYPES: APIFieldLatest["type"][] = [
  "string",
  "text",
  "email",
];

export const ALLOWED_CHECKLIST_LABEL_FIELD_TYPES: APIFieldLatest["type"][] = [
  "labeled_string",
  "multiple_labeled_string",
];

export const ALLOWED_CHECKLIST_COMPLETED_FIELD_TYPES: APIFieldLatest["type"][] =
  ["boolean"];

export const ALLOWED_CHECKLIST_DUE_DATE_FIELD_TYPES: APIFieldLatest["type"][] =
  ["datetime"];

export const ALLOWED_CHECKLIST_SORT_BY_FIELD_TYPES: APIFieldLatest["type"][] = [
  "text",
  "number",
  "datetime",
  "decimal",
  "string",
];
